import React, { useEffect } from 'react'
import './HelperQuotaModal.css'

// Shown after a free student finishes the session that fills the weekly
// pool, and again when a later attempt is refused. Closing it does not
// grant a session. The parent-invite panel sits below the copy.
const HelperQuotaModal = ({ onClose, children }) => {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        onClose()
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [onClose])

  return (
    <div className='helper-quota-modal-overlay' onClick={onClose}>
      <div
        className='helper-quota-modal'
        role='dialog'
        aria-modal='true'
        aria-labelledby='helper-quota-modal-title'
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type='button'
          className='helper-quota-modal-close'
          onClick={onClose}
          aria-label='Close'
        >
          ×
        </button>
        <h2 id='helper-quota-modal-title' className='helper-quota-modal-title'>
          Weekly limit reached
        </h2>
        <p className='helper-quota-modal-body'>
          You are now out of Explain and Check Answer sessions for this week.
        </p>
        <div className='helper-quota-modal-panel'>
          {children}
        </div>
        <button
          type='button'
          className='helper-quota-modal-done'
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  )
}

export default HelperQuotaModal
